export enum FeatureFlag {
  ShowSignalPostsContext = 'showSignalPostsContext',
  ShowNewEventsUi = 'showNewEventsUi',
  MarkAlertAsMonitoring = 'showAlertStatusMonitoring',
  SupplyChainMonitoring = 'supplyChainMonitoring',
  AnalystTools = 'analystTools',
  DrpSnapshot = 'drpSnapshot',
  NewLandingPage = 'newLandingPage',
  KarlaAssist = 'karlaAssist',
  AnalyticsBotnetFilters = 'analyticsBotnetFilters',
}

export const FEATURE_FLAGS = Object.values(FeatureFlag);

export type FeatureFlagsState = Partial<Record<FeatureFlag, boolean>>;
